// extracted by mini-css-extract-plugin
module.exports = {"otpContainer":"OtpInput_otpContainer___GDlN","otpInput":"OtpInput_otpInput__NNRcF","otpInputError":"OtpInput_otpInputError__lV__z","errorText":"OtpInput_errorText__Q4Mqs"};